import styled from '@emotion/styled';
import Note from '@assets/svg/message.svg';
import Tooltip from '@components/Tooltips/Tooltip';
import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import { useRef, useState } from 'react';
import TagsPopup from './TagsPopup';

const Container = styled.div<{interact?:boolean, swipeView?: boolean; show?: boolean, fullDayView?: boolean }>`
  pointer-events: ${(props) => (props.interact ? 'none' : 'unset')};;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 100%;
  pointer-events: all;
  font-weight: bold;
  z-index: 10;
  cursor:  ${(props) => (props.interact ? 'default' : 'unset')};;

  > div {
    height: 100%;
    pointer-events: ${(props) => (props.interact ? 'none' : 'unset')};;

    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div > svg {
    pointer-events: ${(props) => (props.interact ? 'none' : 'unset')};;
    height: 100%;
  }
`;

const NoteCount = styled.div<{ swipeView?: boolean; }>`
  position: absolute;
  top: ${(props) => (props.swipeView ? '-8px' : '-4px')};
  right: ${(props) => (props.swipeView ? '-8px' : '-4px')};
  width: ${(props) => (props.swipeView ? '24px' : '14px')};
  height: ${(props) => (props.swipeView ? '24px' : '14px')};
  background: red;
  color: #fff;
  font-size: ${(props) => (props.swipeView ? '12px' : '8px')};
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IProps {
  id?: any;
  show?: boolean;
  notecount?: number;
  swipeView?: boolean;
  interact?:boolean;
  fullDayView?:boolean;
}

export const HaveNote = (props: IProps) => {
  const { setNote, callNameSetting, setNoteUserId, systemSettings } = useStore();
  const i18n = useI18n();
  const [tagsOpen, setTagsOpen] = useState(false);

  let allowFreeTextNotes = systemSettings.find((s) => s.APP_Setting_ID === 42);

  let tooltiptext =
     props.notecount > 0
        ? props.notecount === 1
          ? i18n.t(callNameSetting + '-tooltip-newnote-one', { count: props.notecount })
          : i18n.t(callNameSetting + '-tooltip-newnote-more', { count: props.notecount })
        : i18n.t(callNameSetting + '-tooltip-note')

  const handleNoteClick = (e) => {
      e.stopPropagation();
      setNoteUserId(props.id);
      setNote(true);
  };

  return (
    <Container interact={props.interact} onClick={(e) => props.interact?"":handleNoteClick(e)} swipeView={props.swipeView} fullDayView={props.fullDayView} show={props.show}>
      <Tooltip offsetY={-6} content={tagsOpen ? null : tooltiptext} placement="top-center">
        <Note />
        {props.notecount > 0 && (
          <NoteCount swipeView={props.swipeView}>
            {props.notecount}
          </NoteCount>
        )}
      </Tooltip>
    </Container>
  );
};

export default HaveNote;
